import { FC } from 'react';
import { TableStyled, TableViewportScroller } from './TableV2.styles';
import { ITableV2Props } from './TableV2.types';

export const TableV2: FC<ITableV2Props> = ({ caption, textAlign = 'left', children, ...tableProps }) => (
  <TableViewportScroller>
    <TableStyled textAlign={textAlign} {...tableProps}>
      <caption>{caption}</caption>
      {children}
    </TableStyled>
  </TableViewportScroller>
);

TableV2.displayName = 'TableV2';
